export const SUBTOTAL_TITLE_TEST_ID = {
  tooltip: 'subtotal-tooltip',
  infoIcon: 'subtotal-info-icon',
};
